import * as angular from 'angular';

import { ISeriesConfiguration, WidgetWithErrors } from '../../widgets';
import { Helper } from '../../common';
import { WidgetValuesReadConfiguration, AggregationConfiguration, ReadType, IBindable } from '../../models';
import { IwidgetIntervalHelperService, IDateRangeService } from '../../services';
import { BusinessKpiConfiguration } from './businessKpi.configuration';
import { BusinessKpiWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class BusinessKpiWidget extends WidgetWithErrors {
    baseType = definition.baseType;
    col = 0;
    configuration: BusinessKpiConfiguration;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    private __intervalHelper;

    constructor(private _$q: angular.IQService,
        intervalHelper: IwidgetIntervalHelperService,
        private _dateRangeService: IDateRangeService) {
        super(intervalHelper);
        this.__intervalHelper = intervalHelper;
        this.guid = Helper.getGuid();
        this.configuration = new BusinessKpiConfiguration();
    }

    interval() {
        const result = this.__intervalHelper.getInterval(this._dateRangeService.beginDate() as string, this._dateRangeService.endDate() as string, this.configuration);
        return result;
    }

    getSeriesGuids(): string[] {
        return this.configuration.kpis.map(d => d.guid);
    }

    getReadConfiguration(beginDate, endDate): WidgetValuesReadConfiguration {
        const aggregation: AggregationConfiguration = {
            period: null,
            mode: this.configuration.aggregationMode
        };
        return this.getReadConfigurationBase(beginDate, endDate, this.configuration.kpis, this.configuration, aggregation,
            true, true, true, false, false, ReadType.AggregatedValue);
    }

    getSeriesListAsync(): angular.IPromise<IBindable[]> {
        const result = this.configuration.kpis
            ? this.configuration.kpis.map(d => {
                return {
                    guid: d.guid,
                    originalGuid: d.guid,
                    value: d.value,
                    //relativePath: d.relativePath,
                    isBoundToGroup: d.isBoundToGroup
                };
            })
            : [];
        return this._$q.when(result);
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        return this.getSeriesListAsync()
            .then(data => {
                const hasQuality = true;
                const hasMissingRanges = false;
                const hasContext = true;
                const hasTendency = true;
                const hasTarget = false;
                const aggregation: AggregationConfiguration = {
                    period: null,
                    mode: this.configuration.aggregationMode
                };
                const widgetValuesReadConfiguration = this.createConfiguration(data, aggregation, hasQuality, hasMissingRanges, hasContext,
                    hasTendency, hasTarget, ReadType.AggregatedValue);
                return widgetValuesReadConfiguration;
            });
    }

    getSeries(): ISeriesConfiguration[] {
        return (this.configuration as any).kpis;
    }

    setSeries(series: ISeriesConfiguration[]) {
        (this.configuration as any).kpis = series;
    }
}